import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute'; 

import ReveenLayout from './components/reveen/Layout';
import ReveenAppLayout from './components/reveen/AppLayout';

import ReveenLogin from './pages/reveen/Login';
import ReveenDashboard from './pages/reveen/Dashboard';
import ReveenMaster from './pages/reveen/Master';
import ReveenProduct from './pages/reveen/Product';
import ReveenLocation from './pages/reveen/Location';
import ReveenDeliveryPartner from './pages/reveen/DeliveryPartner';
import ReveenShop from './pages/reveen/Shop';
import ReveenCustomer from './pages/reveen/Customer';
import ReveenSignup from './pages/reveen/Signup';
import ReveenHome from './pages/reveen/Home';
import ReveenSubscribe from './pages/reveen/Subscribe';
import ReveenMySubscriptions from './pages/reveen/MySubscriptions';
import ReveenCheckout from './pages/reveen/Checkout';
import DummyGateway from './pages/reveen/DummyGateway';
import VerifyMandateFrontend from './pages/reveen/VerifyMandateFrontend';
import AdminPayment from './pages/reveen/AdminPayment';
import AdminSubscription from './pages/reveen/AdminSubscription';
import AdminDelivery from './pages/reveen/AdminDelivery';
import AdminMessageLog from './pages/reveen/AdminMessageLog';
import AdminDeliveryReport from './pages/reveen/AdminDeliveryReport';

const params = new URLSearchParams(window.location.search);
export let APPSETTING = localStorage.getItem('appsetting') ? JSON.parse(localStorage.getItem('appsetting') || "{}"): null;
//console.log("APPSETTING > ", APPSETTING);
if (!APPSETTING?.appname && !params.get("appname") && document.location.href.match(/senddit.in|ssl.itpatil.com/gi) ) {
  APPSETTING = {adminuserid:"6a043a73ef964e67e1c77ec0", appname:"whatsappapi"};
  localStorage.setItem("appsetting", JSON.stringify(APPSETTING));
} else if (params.get("appname")) {
  APPSETTING = {adminuserid:params.get("adminuserid"), appname:params.get("appname")};
  localStorage.setItem("appsetting", JSON.stringify(APPSETTING));
}
console.log(APPSETTING);
window.APPSETTING = APPSETTING;


const link = document.createElement('link');
link.rel = 'stylesheet';
let csshref = `/css/trader/style.css`;
document.head.appendChild(link);
let title = "Reveen";
if (APPSETTING?.appname == "reveen") {
  csshref = csshref.replace("trader", "reveen");
  title = "Reveen";
}

link.href = csshref;
$(".pagetitle").html(title);

export const APPUSER = JSON.parse(localStorage.getItem(APPSETTING.appname + "user") || "{}");
window.APPUSER = APPUSER;


ReactDOM.createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <Routes>
        
      {/* Reveen Routing */}
      {window.APPSETTING?.appname === "reveen" && (
        <Route path="/" element={<ReveenLayout />}>
       
          <Route path="/login" element={<ReveenLogin />} />
          <Route path="/shop" element={<ReveenShop />} />
          <Route path="/signup" element={<ReveenSignup />} />


          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<ReveenHome />} />
            <Route path="/subscribe" element={<ReveenSubscribe />} />
            <Route path="/subscriptions" element={<ReveenMySubscriptions />} />
            <Route path="/checkout/:id" element={<ReveenCheckout />} />
            <Route path="/dashboard" element={<ReveenAppLayout />}>
              <Route index element={<ReveenDashboard />} />
            </Route>
            <Route path="/master" element={<ReveenAppLayout />}>
              <Route index element={<ReveenMaster />} />
            </Route>
            <Route path="/product" element={<ReveenAppLayout />}>
              <Route index element={<ReveenProduct />} />
            </Route>
            <Route path="/location" element={<ReveenAppLayout />}>
              <Route index element={<ReveenLocation />} />
            </Route>
            <Route path="/deliverypartner" element={<ReveenAppLayout />}>
              <Route index element={<ReveenDeliveryPartner />} />
            </Route>
            <Route path="/customer" element={<ReveenAppLayout />}>
              <Route index element={<ReveenCustomer />} />
            </Route>

            <Route path="/dummygateway" element={<DummyGateway />} />
            <Route path="/verifymandatefrontend" element={<VerifyMandateFrontend />} />

            <Route path="/adminpayment" element={<ReveenAppLayout />}>
              <Route index element={<AdminPayment />} />
            </Route>
            <Route path="/adminsubscription" element={<ReveenAppLayout />}>
              <Route index element={<AdminSubscription />} />
            </Route>
            <Route path="/admindelivery" element={<ReveenAppLayout />}>
              <Route index element={<AdminDelivery />} />
            </Route>
            <Route path="/adminmessagelog" element={<ReveenAppLayout />}>
              <Route index element={<AdminMessageLog />} />
            </Route>
            <Route path="/admindeliveryreport" element={<ReveenAppLayout />}>
              <Route index element={<AdminDeliveryReport />} />
            </Route>
          </Route>
        </Route>
      )}

      </Routes>
    </BrowserRouter>
)

// TypeScript Declaration (add to a d.ts file or top of file)
declare global {
  interface Window { APPSETTING: any; APPUSER:any;}
}
